import { render, staticRenderFns } from "./TemplateRedirectBtn.vue?vue&type=template&id=dcf04ada&"
import script from "./TemplateRedirectBtn.vue?vue&type=script&lang=js&"
export * from "./TemplateRedirectBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports